import { render, staticRenderFns } from "./drm.vue?vue&type=template&id=9e96ea0e&scoped=true&"
import script from "./drm.vue?vue&type=script&lang=js&"
export * from "./drm.vue?vue&type=script&lang=js&"
import style0 from "./drm.vue?vue&type=style&index=0&id=9e96ea0e&scoped=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e96ea0e",
  null
  
)

export default component.exports